export default {"src":"/_next/static/media/xmcc.a0d0a9d2.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};